__webpack_require__.p = "https://mosaic-dev.ask-ai.co/";